import * as React from "react";
import { FormikProps } from "formik";
import FormGroup from "@material-ui/core/FormGroup";
import FormPaper from "@components/atoms/FormPaper";
import SectionTitle from "@components/atoms/SectionTitle";
import HelpToolTip from "@components/atoms/HelpToolTip";
import HelpTipMessages from "@components/molecules/HelpTipMessages";
import FormikTextField from "@components/molecules/FormikTextField";
import FormikCheckbox from "@components/molecules/FormikCheckbox";
import FormikSwitch from "@components/molecules/FormikSwitch";
import FormikPostalCode from "@components/molecules/FormikPostalCode";
import FormikAddress from "@components/molecules/FormikAddress";
import OfficeField from "@components/v201910/organisms/mgr/common/facility/items/OfficeField";
import ServiceTypeField from "@components/v201910/organisms/mgr/common/facility/items/ServiceTypeField";
import FacilityTypeField from "@components/v201910/organisms/mgr/common/facility/items/FacilityTypeField";
import {
  SUPPLY_PICKUP_SERVICE_ITEMS,
  SEIKATSUKAIGO_TYPE_LIST
} from "@constants/mgr/SEIKATSUKAIGO/variables";
import { Typography } from "@material-ui/core";
import FormikSelect from "@components/molecules/FormikSelect";
import { FacilityValues } from "@initialize/v201910/mgr/SEIKATSUKAIGO/facility/initialValues";
import { MultiFunctionMasterSubordinateFormGroup } from "@components/organisms/mgr/common/facility/items/MultiFunctionMasterSubordinateFormGroup";

type Props = {
  isFetchDone: boolean;
  serviceType: string;
  facilityType: number;
  formikProps: FormikProps<FacilityValues>;
  setFormikFieldValue: (
    fieldName: string,
    value: number | string | boolean
  ) => void;
};

export const BasicFields = (props: Props): JSX.Element => {
  return (
    <FormPaper>
      <div style={{ marginBottom: 32 }}>
        <SectionTitle label="基本情報" />
      </div>
      <FormikTextField
        name="basic.corporationName"
        label="法人名"
        placeholder="株式会社ノウビー"
        maxLength={255}
        size="superLong"
      />
      <OfficeField />
      <FormGroup row>
        <ServiceTypeField serviceType={props.serviceType} />
        <FacilityTypeField
          facilityType={`${props.facilityType}`}
          facilityTypeList={SEIKATSUKAIGO_TYPE_LIST}
        />
      </FormGroup>
      <FormikTextField
        name="basic.representativeName"
        label="代表職員氏名"
        placeholder="山田太郎"
        maxLength={20}
        size="superLong"
      />
      <FormikTextField
        name="basic.capacity"
        label="利用定員数"
        placeholder="0"
        maxLength={10}
        endAdornmentLabel="名"
      />

      {/* 多機能主従の設定項目 */}
      <MultiFunctionMasterSubordinateFormGroup
        masterSubordinateFlg={
          props.formikProps.values.basic.masterSubordinateFlg
        }
        multiFunctionOfficeFlag={
          props.formikProps.values.basic.multiFunctionOfficeFlag
        }
        nameOfMasterFlg="basic.masterFlg"
        nameOfMultiFunctionOfficeFlag="basic.multiFunctionOfficeFlag"
      />

      <FormikPostalCode
        name="basic.postalCode"
        label="郵便番号"
        placeholder="000-0000"
        maxLength={8}
        startAdornmentLabel="〒"
      />
      <FormikAddress
        prefectureIdName="basic.prefectureId"
        cityIdName="basic.cityId"
        formikProps={props.formikProps}
      />
      <FormikTextField
        name="basic.restAddress"
        label="市区町村以降の住所"
        size="superLong"
      />
      <FormikTextField
        name="basic.tel"
        type="tel"
        label="電話番号"
        maxLength={12}
        placeholder="0000000000"
      />
      <Typography>実施オプションサービス</Typography>
      <FormGroup style={{ paddingTop: 17, paddingLeft: 17 }}>
        <FormikCheckbox
          name="basic.mealSaservedServiceFlag"
          label="食事提供サービス"
        />
        <FormikSwitch
          name="basic.transferServiceFlag"
          label="送迎サービス"
          style={{ marginBottom: 0 }}
        >
          <FormikSelect
            name="basic.transferServiceType"
            label=""
            options={SUPPLY_PICKUP_SERVICE_ITEMS}
            disabled={false}
            style={{ marginBottom: 0 }}
          />
          <FormikCheckbox
            name="basic.seriousSupporterFlg"
            label="送迎加算（重度）"
            style={{ marginTop: 14 }}
            tooltip={
              <HelpToolTip
                title={<HelpTipMessages name="seriousSupporterFlg" />}
              />
            }
          />
        </FormikSwitch>
      </FormGroup>
    </FormPaper>
  );
};
